export default __webpack_public_path__ + "static/media/move.92f9ea8b.svg";